import { useAddBranches } from '../actions/useAddBranches';
import { useOrganiseBranches } from '../actions/useOrganiseBranches';
import { useUpdateBranch } from '../actions/useUpdateBranch';
import { useAreBranchesLoadedFromServerSelector } from '../selectors/useAreBranchesLoadedFromServerSelector';
import { useBranchSelector } from '../selectors/useBranchSelector';
import { useBranchesSelector } from '../selectors/useBranchesSelector';

export const useBranches = () => {
  const addBranches = useAddBranches();
  const updateBranch = useUpdateBranch();
  const organiseBranches = useOrganiseBranches();

  const branchSelector = useBranchSelector();
  const branches = useBranchesSelector();
  const areBranchesLoadedFromServer = useAreBranchesLoadedFromServerSelector();

  return {
    addBranches,
    updateBranch,
    organiseBranches,

    branchSelector,
    branches,
    areBranchesLoadedFromServer,
  };
};
